import { gql } from '@apollo/client';

export const GET_CUSTOMER_EXAMPLE_FILE = gql`
  query GetCustomerExampleFile {
    customerExampleFile
  }
`; 